require('./vue-init')
require('./webcomponent')
require('./ld_compatibility')
